import { render, staticRenderFns } from "./WsFooterInfoItemList.vue?vue&type=template&id=0061dc60&scoped=true"
import script from "./WsFooterInfoItemList.vue?vue&type=script&lang=js"
export * from "./WsFooterInfoItemList.vue?vue&type=script&lang=js"
import style0 from "./WsFooterInfoItemList.vue?vue&type=style&index=0&id=0061dc60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0061dc60",
  null
  
)

export default component.exports